import React, { Component } from 'react'
import { connect } from 'react-redux'
import preload from 'components/enhancer/preload'
import { actions } from './redux'
import composeHOC from 'shared/utils/composeHOC'
import { Link } from 'react-router'
import Meta from 'components/layout/Meta';

class AnnouncementDetail extends Component {
  constructor(props) {
    super(props)
    this.needLeftNavigation = false
  }
  state = {
  }
  componentDidMount(){
  }
  render() {
    const {announcement} = this.props
    return(
      <div className="newsDetail rightCon  newsDetailCon clearfix">
        <Meta location={this.props.location} pathname={this.props.location} title={announcement.currentData.title + '-公司公告-关于我们'} />
        <div className="newsCon" style={{borderRight: 'none'}}>
          <div className="newsTitle">
            <h1 className="newsTitle-text">{announcement && announcement.currentData.title}</h1>
          </div>
          <br></br>
          <div dangerouslySetInnerHTML={{__html: announcement && announcement.currentData.content}}>
          </div>
          <br></br><br></br><br></br>
        </div>
      </div>
    )
  }
}


export default composeHOC(
  connect(state => ({
    announcement: state.aboutUs.announcement
  }), {
  }),
  preload(({dispatch, location}) => {
    const announcementId = location.pathname.substr( location.pathname.lastIndexOf('/') + 1 )
    return Promise.all([
      dispatch(actions.getAnnouncementDetail(announcementId))
    ])
  })
)(AnnouncementDetail)



// WEBPACK FOOTER //
// ./modules/aboutUs/AnnouncementDetail.js